import { combineReducers } from '@reduxjs/toolkit';

import { userSlice } from './user/user.slice';

export const loyaltyReducer = combineReducers({ user: userSlice.reducer });
